import React, { useEffect, useState } from 'react'
import { ThingFlag } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import useCtr from '../../hooks/useCtr'
import SubnavAndRoutes from '../app/SubnavAndRoutes'
import MetaData from '../metadata/MetaData'
import CtrChanges from './changes/CtrChanges'
import CtrContextProvider from './CtrContext'
import CtrSummary from './summary/CtrSummary'
import CtrRawData from './CtrRawData'
import { marginTop } from '../../util/CssUtil'
import { getCtrChanges } from '../../services/CtrService'
import useNotifications from '../../hooks/useNotifications'

const mt10 = marginTop('10px')

export default function CtrBase({ match }) {
  const { t } = useTranslation()
  const cid = match.params.ctrId
  const { currentCtr, fetchCurrentCtr } = useCtr(cid)
  const [ctrChangesList, setCtrChangesList] = useState([])
  const ctrContext = { currentCtr, fetchCurrentCtr, ctrChangesList }
  const { error } = useNotifications()

  useEffect(() => {
    currentCtr?.templePlatform?.ctrs?.length > 0 &&
      getCtrChanges(currentCtr.templePlatform.ctrs?.[0].id)
        .then((response) => {
          setCtrChangesList(response?.data.entries || [])
        })
        .catch((err) => {
          error(
            t('ctr.errors.errorRetrievingCtrChanges', {
              defaultValue: `Error retrieving CTR changes: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
  }, [currentCtr?.templePlatform?.ctrs, error, setCtrChangesList, t])

  const subNavs = [
    {
      text: t('ctr.summary.label', 'Summary'),
      path: 'summary',
      requiredPermissions: ['tss_ReadCtrControlledPermission', 'tss_ReadCtrFullAcdPermission'],
      component: CtrSummary,
    },
    {
      text:
        ctrChangesList?.length > 0 ? (
          <span>
            <span style={{ color: '#bd0057', position: 'relative' }}>{t('ctr.changes.label', 'Changes')}</span>
            <ThingFlag size="xs" color="#bd0057" />
          </span>
        ) : (
          t('ctr.changes.label', 'Changes')
        ),
      path: 'changes',
      requiredPermissions: ['tss_ReadCtrControlledPermission', 'tss_ReadCtrFullAcdPermission'],
      component: CtrChanges,
    },
    {
      text: t('ctr.rawData.label', 'Raw Data'),
      path: 'rawdata',
      requiredPermissions: ['tss_ReadCtrControlledPermission', 'tss_ReadCtrFullAcdPermission'],
      component: CtrRawData,
    },
  ]
  if (currentCtr === null) {
    return <>{t('ctr.lookupCtr', 'Look up a CTR to view CTR data')}</>
  }
  if (currentCtr === undefined) {
    return null
  }
  return (
    <CtrContextProvider value={ctrContext}>
      <MetaData metadata={currentCtr.metadata} />
      <SubnavAndRoutes data={subNavs} css={mt10} />
    </CtrContextProvider>
  )
}
